export default __webpack_public_path__ + "static/media/content-img-1.089100ed.jpg";